module.exports = __webpack_public_path__ + "static/icob_happiness-49eaf547d47125e7d30f881a0a405b76.png";